<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="skuQueryForm" :model="skuQueryForm" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="skuQueryForm.categoryId"
                placeholder="请选择"
                @change="
                  getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    skuQueryForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="skuQueryForm.brandId"
                placeholder="请选择"
                @change="skuTree"
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="skuQueryForm.modelId"
                placeholder="请选择机型"
                filterable
              >
                <el-option
                  v-for="item in skuInfo.phoneModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col>
              <el-button type="primary" @click="getHsbQuoteWhiteList">查询</el-button>
              <el-button type="primary" @click="addSku">添加</el-button>
            </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="编号"> </el-table-column>
        <el-table-column prop="modelName" label="机型"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="deleteHsbQuoteWhite(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑SKU' : '新建SKU'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editSkuForm"
            :model="editSkuForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editSkuForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editSkuForm.categoryId"
                placeholder="请选择"
                @change="
                  dlgChangeCategory(
                    'phoneBrand',
                    'dlgBrandOptions',
                    editSkuForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editSkuForm.brandId"
                placeholder="请选择"
                @change="skuTree"
              >
                <el-option
                  v-for="item in dlgBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelId">
              <el-select
                clearable
                v-model="editSkuForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in skuInfo.phoneModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorSkuDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      skuQueryForm: {
        categoryId: null,
        brandId: null,
        channelId: null,
        colorId: null,
        durationId: null,
        memoryId: null,
        modelId: null,
        networkId: null,
        smallId: null,
        cpuId: null,
        graphicsId: null,
        solidId: null,
        mechanicalId: null,
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      fullscreenLoading:false,

      // 新建编辑对话框数据

      isDlg: false,
      editSkuForm: {
        id: null,
        name: null,
        brandId: null,
        categoryId: null,
        channelId: null,
        colorId: null,
        durationId: null,
        memoryId: null,
        modelId: null,
        networkId: null,
        smallId: null,
        cpuId: null,
        graphicsId: null,
        solidId: null,
        mechanicalId: null,
        status: 0,
      },

      editorFormRules: {
        modelId: [{ required: true, message: "请输入机型", trigger: "change" }],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      skuInfo: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteHsbQuoteWhite(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteHsbQuoteWhite({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getHsbQuoteWhiteList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getHsbQuoteWhiteList();
    },

    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },

    // 获取表格数据
    getHsbQuoteWhiteList() {
      let self = this;
      self.$api
        .listHsbQuoteWhiteSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.skuQueryForm.categoryId || null,
          brandId: self.skuQueryForm.brandId || null,
          modelId: self.skuQueryForm.modelId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addSku() {
      this.dlgType = "new";
      this.editSkuForm=this.$options.data().editSkuForm;
      this.$nextTick(()=>{
          this.$refs['editSkuForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editorSku(row) {
      let self = this;
      self.dlgType = "change";
      self.editSkuForm = row;

      self.getSelectOptions(
        "phoneBrand",
        "dlgBrandOptions",
        self.editSkuForm.categoryId
      );
      self.skuTree(self.editSkuForm.brandId);
      self.isDlg = true;
    },

    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
      this.editSkuForm.parentId = null;
    },

    // 关闭编辑对话框
    closeEditorSkuDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editSkuForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editSkuForm) {
            params[i] = this.editSkuForm[i];
          }
          self.$api.addHsbQuoteWhite(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getHsbQuoteWhiteList();
              self.closeEditorSkuDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      this.$api.updateSKu(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getHsbQuoteWhiteList();
        }
      });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      this.$api
        .swap({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getHsbQuoteWhiteList();
          }
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getHsbQuoteWhiteList();
    self.getSelectOptions("category", "categoryOptions");
  },
};
</script>
<style lang="less" scoped></style>
